import moment from 'moment';

import {omitNull} from 'common/utils';


export default class ServiceException {
  /* eslint-disable camelcase */
  constructor({
    _id,
    start_time,
    end_time,
    type,
    message,
  }) {
    this._id = _id || btoa(start_time + end_time);
    this.start_time = start_time
      ? moment.utc(start_time)
      : moment.utc();
    this.end_time = end_time
      ? moment.utc(end_time)
      : moment.utc();
    this.type = type || 'service_removed';
    this.message = message || '';
  }
  /* eslint-enable camelcase */

  get startTime() {
    if (this.start_time) return this.start_time;
    return moment.utc();
  }

  set startTime(value) {
    this.start_time = value;
  }

  get endTime() {
    if (this.end_time) return this.end_time;
    return moment.utc();
  }

  set endTime(value) {
    this.end_time = value;
  }

  get removal() {
    return this.type === 'service_removed';
  }

  clone() {
    return new ServiceException(this.serialize());
  }

  serialize() {
    return omitNull({
      _id: this._id,
      start_time: this.start_time.format('Y-MM-DDTHH:mm:ss.SSS[Z]'),
      end_time: this.end_time.format('Y-MM-DDTHH:mm:ss.SSS[Z]'),
      type: this.type,
      message: this.message,
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/types/ServiceException.js